// extracted by mini-css-extract-plugin
module.exports = {"selected":"styles_selected__1e_6Q"};